import React from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';
import { compose, pure } from 'recompose';
import { routes } from '../../../constants';
import { About, Artist, Artists, Contact, Event, Events, Home, Login, NewPassword, NotFound } from '../../pages';
import { AppNav, Footer } from '../../partials';
import './app.css';

const App = () => (
  <section className='app'>
    <header>
      <AppNav />
    </header>
    <main>
      <Switch>
        <Route exact path={routes.home} component={Home} />
        <Route path={routes.login} component={Login} />
        <Route path={routes.newPassword} component={NewPassword} />
        <Route path={routes.artist()} component={Artist} />
        <Route path={routes.artists} component={Artists} />
        <Route path={routes.event()} component={Event} />
        <Route path={routes.events} component={Events} />
        <Route path={routes.about} component={About} />
        <Route path={routes.contact} component={Contact} />
        <Route component={NotFound} />
      </Switch>
    </main>
    <Footer />
  </section>
);

export default compose(
  withRouter,
  pure
)(App);



// WEBPACK FOOTER //
// ./src/components/layouts/app/app.js